import React, { FunctionComponent, useEffect, useState } from 'react';
import { useAuthContext } from '@havenengineering/module-shared-owners-ui/dist/contexts/auth';
import useSWRImmutable from 'swr/immutable';

import { swrFetcher } from '../../../helpers/fetch';
import { Park } from '../../../types/parks';

const FacebookFeed: FunctionComponent = () => {
  const { activeAccount } = useAuthContext();
  const fbContainerRef = React.createRef<HTMLDivElement>();
  const [fbContainerWidth, setFbContainerWidth] = useState<number>(0);

  const park = useSWRImmutable<Park>(
    activeAccount?.parkCode && `/parks/${activeAccount.parkCode}`,
    swrFetcher
  ).data;

  useEffect(() => {
    if (fbContainerRef.current)
      setFbContainerWidth(fbContainerRef.current.offsetWidth);
  }, [fbContainerRef]);

  useEffect(() => {
    if ((window as any)?.FB?.XFBML && fbContainerWidth) {
      (window as any).FB.XFBML.parse();
    }
  }, [fbContainerWidth, activeAccount]);

  return (
    <>
      {park?.facebookURL && (
        <div ref={fbContainerRef} data-testid="fb-feed-container">
          <div
            className="fb-page"
            style={{ marginTop: 18 }}
            data-href={park.facebookURL}
            data-height={'450px'}
            data-width={`${fbContainerWidth}px`}
            data-small-header="true"
            data-adapt-container-width="true"
            data-hide-cover="false"
            data-tabs="timeline"
          />
        </div>
      )}
    </>
  );
};

export default FacebookFeed;
